import styled, { css } from 'styled-components'
import { SystemBoldChevrondown } from '@dasa-health/icons'

const fieldHeight = '56px'

const colors = {
    default: '#94969e',
    active: '#0037ff',
    error: '#e51a45',
}

export const Arrow = styled(SystemBoldChevrondown)<{ error: string }>`
    position: absolute;
    right: 12px;
    top: 20px;
    z-index: -1;
    filter: ${({ error }) =>
        error ? 'invert(25%) sepia(91%) saturate(6148%) hue-rotate(339deg) brightness(93%) contrast(93%)' : 'opacity(0.5);'};
`

export const SelectWrapper = styled.div`
    position: relative;
    width: 100%;
    height: ${fieldHeight};

    .select-label {
        color: ${colors.default};
        background: white;
        font-size: 1em;
        font-weight: normal;
        position: absolute;
        pointer-events: none;
        left: 0.75em;
        top: 16px;
        transition: 0.2s ease all;
    }
`

export const SelectField = styled.select<{ error: boolean; isEmpty: boolean }>`
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    height: ${fieldHeight};
    position: relative;
    font-family: inherit;
    background-color: transparent;
    width: 100%;
    padding: 10px 10px 10px 10px;
    font-size: 1em;
    border-radius: 4px;
    border: 1px solid ${colors.default};

    :focus {
        outline: none;
        border: 1px solid ${colors.active};
    }

    :focus ~ .select-label {
        color: ${colors.active};
        top: -10px;
        transition: 0.2s ease all;
        font-size: 0.75em;
        padding: 0 2px;
    }

    ${({ isEmpty }) =>
        !isEmpty &&
        css`
            ~ .select-label {
                color: ${colors.default};
                top: -10px;
                transition: 0.2s ease all;
                font-size: 0.75em;
                padding: 0 2px;
            }

            :focus ~ .select-label {
                color: ${colors.active};
            }
        `}

    ${({ error }) =>
        error &&
        css`
            border: 1px solid ${colors.error};

            ~ .select-label {
                color: ${colors.error};
            }
            :focus {
                border-color: ${colors.error};
            }

            :focus ~ .select-label {
                color: ${colors.error};
            }
        `}
`

export const FieldError = styled.span`
    position: absolute;
    bottom: -22px;
    left: 0;
    display: flex;
    flex-wrap: wrap;
    white-space: nowrap;
    min-width: 0;
    margin: 0;
    margin-left: 0.5em;
    margin-top: 0.25em;
    color: ${colors.error};

    > span {
        white-space: normal;
        margin-left: 0.5em;
        margin-right: 0.5em;
        font-size: 0.75em;
    }
`
